import React from 'react';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { DefaultButton } from '@fluentui/react/lib/Button';
import { tutorStepPropTypes } from './step-component-props';
import { StyledInstructions } from './instructions';
import troubleshootUETTag from '../../media/troubleshootUETTag.png';

export const TroubleshootUETTag = (props) => {
  const { i18n } = props;
  const text = i18n.getString(_TL_('Reference our UET help articles for information on how to troubleshoot your tag status.'));
  const content = (
    <p>
      <ReactTemplate template={text} />
    </p>
  );
  const troubleshootButton = (<DefaultButton text={i18n.getString(_TL_('Troubleshoot UET tag'))} id="troubleshootUETTag" onClick={() => window.open('https://help.ads-int.microsoft.com/#apex/ads/en/56692/1/en-US/#ext:vnext_offlineconversions')} />);
  const download = null;

  return (
    <React.Fragment>
      <StyledInstructions
        title={i18n.getString(_TL_('Troubleshoot UET tag'))}
        imageSrc={troubleshootUETTag}
        descTemp={content}
        downloadInstructions={download}
        button={troubleshootButton}
        i18n={i18n}
      />
    </React.Fragment>
  );
};

TroubleshootUETTag.propTypes = tutorStepPropTypes;
